// INFO - AG 28/06/2023 - This function allow to convert in readable duration the field formatted by the back api
// from this format "P1Y8M1D" to "20 months 1 days"
export const convertRelativeDeltaField = (durationString) => {
  // For ISO 8601 durations, only negative days allowed
  const matches = durationString.match(/P(\d+Y)?(\d+M)?(-)?(\d+D)?/);
  const years = parseInt(matches[1], 10) || 0;
  const months = parseInt(matches[2], 10) || 0;
  const isNegative = matches[3] === "-";
  const days = parseInt(matches[4], 10) || 0;
  const totalMonths = years * 12 + months;
  const totalDays = days;

  return {
    months: totalMonths,
    isNegative: `${isNegative ? "-" : ""}`,
    days: totalDays,
  };
};

// INFO - AG 15/10/2024 - This function calculate the end date from a start date and a duration in month, substract one day
/**
 *
 * @param {string} startDateStr
 * @param {number} duration
 * @returns {string}
 */

export const calculateEndDate = (startDateStr, duration) => {
  const startDate = new Date(startDateStr);
  const endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + duration);
  endDate.setDate(endDate.getDate() - 1);
  return endDate.toISOString().split("T")[0];
};
